/**
 * Stable CSS class names for E2E — Mobile field cargo distribution.
 */
export const MFCD = {
    page: 'mobile-field-cargo-distribution-page',
    breadcrumbSection: 'mobile-field-cargo-distribution-page__breadcrumb-section',
    contentSection: 'mobile-field-cargo-distribution-page__content-section',

    toolbarFiltered: 'mobile-field-cargo-distribution-page__toolbar-filtered',
    toolbarExcelGroup: 'mobile-field-cargo-distribution-page__toolbar-excel-group',
    inputIconSampleExcelInfo: 'mobile-field-cargo-distribution-page-input--icon-sample-excel-info',
    inputButtonExcelUpload: 'mobile-field-cargo-distribution-page-input--button-excel-upload',
    excelFileInput: 'mobile-field-cargo-distribution-page-input--file-excel',
    toolbarActionsRow: 'mobile-field-cargo-distribution-page__toolbar-actions-row',
    inputButtonAddNew: 'mobile-field-cargo-distribution-page-input--button-add-new',
    inputIconOpenFilterDrawer: 'mobile-field-cargo-distribution-page-input--icon-open-filter-drawer',

    gridSection: 'mobile-field-cargo-distribution-page__grid-section',
    gridWrap: 'mobile-field-cargo-distribution-page__grid-wrap',

    emptyGate: 'mobile-field-cargo-distribution-page__empty-gate',
    emptyGateCompanyField: 'mobile-field-cargo-distribution-page__empty-gate-company-field',
    inputSelectEmptyGateCompany: 'mobile-field-cargo-distribution-page-input--select-empty-gate-company',
    emptyGateCityField: 'mobile-field-cargo-distribution-page__empty-gate-city-field',
    inputSelectEmptyGateCity: 'mobile-field-cargo-distribution-page-input--select-empty-gate-city',
    emptyGateCountyField: 'mobile-field-cargo-distribution-page__empty-gate-county-field',
    inputSelectEmptyGateCounty: 'mobile-field-cargo-distribution-page-input--select-empty-gate-county',
    emptyGateNeighborhoodField: 'mobile-field-cargo-distribution-page__empty-gate-neighborhood-field',
    inputSelectEmptyGateNeighborhood: 'mobile-field-cargo-distribution-page-input--select-empty-gate-neighborhood',
    emptyGateFilterActions: 'mobile-field-cargo-distribution-page__empty-gate-filter-actions',
    inputButtonEmptyGateFilter: 'mobile-field-cargo-distribution-page-input--button-empty-gate-filter',

    datagridActionsCell: 'mobile-field-cargo-distribution-datagrid-actions-cell',
    inputIconRowActionsMenu: 'mobile-field-cargo-distribution-datagrid-input--icon-row-actions-menu',
    rowActionsMenuPaper: 'mobile-field-cargo-distribution-datagrid__row-actions-menu',
    inputMenuItemRowEdit: 'mobile-field-cargo-distribution-datagrid-input--menu-item-row-edit',

    filterDrawerRoot: 'mobile-field-cargo-distribution-filter-drawer',
    filterDrawerFieldCompany: 'mobile-field-cargo-distribution-filter-drawer__field-company',
    inputSelectFilterDrawerCompany: 'mobile-field-cargo-distribution-filter-drawer-input--select-company',
    filterDrawerFieldCity: 'mobile-field-cargo-distribution-filter-drawer__field-city',
    inputSelectFilterDrawerCity: 'mobile-field-cargo-distribution-filter-drawer-input--select-city',
    filterDrawerFieldCounty: 'mobile-field-cargo-distribution-filter-drawer__field-county',
    inputSelectFilterDrawerCounty: 'mobile-field-cargo-distribution-filter-drawer-input--select-county',
    filterDrawerFieldNeighborhood: 'mobile-field-cargo-distribution-filter-drawer__field-neighborhood',
    inputSelectFilterDrawerNeighborhood: 'mobile-field-cargo-distribution-filter-drawer-input--select-neighborhood',
    filterDrawerActionsRow: 'mobile-field-cargo-distribution-filter-drawer__actions-row',
    inputButtonFilterDrawerSearch: 'mobile-field-cargo-distribution-filter-drawer-input--button-search',

    addDrawerRoot: 'mobile-field-cargo-distribution-add-drawer',
    addDrawerFieldCompany: 'mobile-field-cargo-distribution-add-drawer__field-company',
    inputSelectAddDrawerCompany: 'mobile-field-cargo-distribution-add-drawer-input--select-company',
    addDrawerFieldCity: 'mobile-field-cargo-distribution-add-drawer__field-city',
    inputSelectAddDrawerCity: 'mobile-field-cargo-distribution-add-drawer-input--select-city',
    addDrawerFieldCounty: 'mobile-field-cargo-distribution-add-drawer__field-county',
    inputSelectAddDrawerCounty: 'mobile-field-cargo-distribution-add-drawer-input--select-county',
    addDrawerFieldNeighborhood: 'mobile-field-cargo-distribution-add-drawer__field-neighborhood',
    inputSelectAddDrawerNeighborhood: 'mobile-field-cargo-distribution-add-drawer-input--select-neighborhood',
    addDrawerFieldWeekly: 'mobile-field-cargo-distribution-add-drawer__field-weekly',
    inputSelectAddDrawerWeekly: 'mobile-field-cargo-distribution-add-drawer-input--select-weekly',
    addDrawerActionsRow: 'mobile-field-cargo-distribution-add-drawer__actions-row',
    inputButtonAddDrawerSubmit: 'mobile-field-cargo-distribution-add-drawer-input--button-submit',
} as const;

export const mfcdCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
